<template>
	<div class="confirm-wrapper">
		<el-steps :active="2" id="steps">
			<el-step title="上传文件"></el-step>
			<el-step title="数据确认"></el-step>
			<el-step title="上传成功"></el-step>
		</el-steps>
		<p id="message">
			<span>
				<span class="color-error">共 {{errorList.length}} 条错误</span>
			</span>
			<span class="color-tip">
				注:鼠标移动到错误单元格上显示错误原因
			</span>
		</p>
		<div id="wrapper" :style="{width: tableWidth + 'px'}">
			<table class="border table-editable tableStyle">
				<tr>
					<th v-for="(column) in columns" :key="column">
						{{column}}
					</th>
				</tr>
				<tr v-for="(item, i) in filteredList" :key="i" :class="{'bg-warning': item.errors && item.errors.duplicate === true }">
					<td v-for="(column, j) in columns" :key="column + j" :title="item.errors && item.errors.fields && item.errors.fields[column]?item.errors.fields[column]:''"
					 :class="{'bg-warning': item.errors && item.errors.fields && item.errors.fields[column]}">
						<div class="inline-flex relative">
							<input v-model="item[column]" />
							<template v-if="j === columns.length - 1">
								<i class="el-icon-circle-plus-outline tygreen operation" @click="addRow(i)"></i>
								<i class="el-icon-remove-outline tygreen operation" @click="deleteRow(i)"></i>
							</template>
						</div>
					</td>
				</tr>
			</table>
		</div>
		<el-row>
			<el-button v-if="skipType !== 'newTab'" type="primary" v-on:click="back">退出</el-button>
			<el-button type="primary" v-on:click="submitImportConfirmData">确认上传</el-button>
		</el-row>
	</div>
</template>
<script>
	import customerService from "../../../service/customerService";
    import {BASE_URL} from "../../../common/config";

	export default {
		components: {},
		computed: {
			columns() {
				let result = [];
				if (this.list.length === 0) {
					return result;
				}

				let first = this.list[0];
				for (let prop in first) {
					if (first.hasOwnProperty(prop) && prop !== 'errors') {
						result.push(prop);
					}
				}
				this.tableWidth = result.length * 120;
				return result;
			},
			filteredList() {
				return this.list;
			},
			errorList() {
				return this.list.filter(item => item.errors);
			}
		},
		data() {
			return {
				mode: 'all',
				list: [],
				tableWidth: '',
                isDisable:false,
				skipType: '',
				categoryId: '',
			};
		},
		mounted() {
            let batch = this.$route.query.batch;
			this.skipType = this.$route.query.skipType;
			this.check(batch);
		},
		watch: {
			'$route'(to, from) {
			    if (this.$route.query.batch) {
					this.getData(this.$route.query.batch);
			    }
			}
		},
		methods: {
			
			async getData(batch) {
				var that = this;
				let resp = await customerService.getImportConfirmData(batch);
				var map = JSON.parse(resp.data.Data);
				console.log(map);
				that.categoryId = map.categoryId;
				var data = map.data;
				data.forEach((item, index) => {
					if (item.errors) {
						item.errors = JSON.parse(item.errors);
					}
				})
				if (resp.data.Status == 1) {
					that.list = data;
				}
			},
			addRow(index) {
				this.list.splice(index + 1, 0, {});
			},
			deleteRow(index) {
				this.list.splice(index, 1);
			},
			back() {
                window.location.href = BASE_URL + '/crm/html/customer/list';
			},
            async check(batch){
                let res = await customerService.getImportConfirmData(batch+".status");
                let loadingInstance=this.$loading({
                    lock: true,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if(res.data.Status==1){
                    var data = JSON.parse(res.data.Data);
                    if(data.status=="pending"){
                        this.isDisable = true;
                        loadingInstance.setText(data.message);
                        setTimeout(()=>{
                            this.check(batch);
                        },1000);
                        return;
                    }
                    if(data.status=="fail"){
                        this.isDisable = false;
                        this.getData(batch);
                        loadingInstance.close();
                        this.$message({
                            message: data.message,
                            type: 'success'
                        });
                        return;
                    }
                    if(data.status=="success"){
                        this.isDisable = false;
                        loadingInstance.close();
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.$router.push({
                            path: '/app/psi/sku/import/UploadSuccess',
                            query: {
                                count: this.list.length,
                                type:'客户',
								skipType:this.skipType,
                                url: BASE_URL+'/crm/html/customer/list'
                            }
                        })
                    }
                }
            },
            async submitImportConfirmData() {
                this.isDisable = true;
                let batch = this.$route.query.batch;
                let list = this.list;
                if (list.length == 0) {
                    this.$router.push({
                        path: '/app/psi/sku/import/UploadSuccess',
                        query: {
                            count: this.list.length,
                            type:'客户',
							skipType:this.skipType,
                            url: BASE_URL+'/crm/html/customer/list'
                        }
                    });
                    return;
                }
                list.forEach((item) => {
                    if (item.errors) {
                        delete item.errors;
                    }
                });
                let resp = await customerService.submitImportConfirmData(JSON.stringify(list), batch,this.categoryId);
                if (resp.data.Status == 1) {
                    this.check(resp.data.Data);
                }
            }
		}
	};
</script>
<style>
	html{
		background: #fff;
	}
	.color-tip{
		color:red;
	}
	.tableStyle {
		table-layout: fixed;
	}

	.tableStyle th {
		width: 120px !important;
	}

	.el-row {
		text-align: center;
		margin-top: 50px;
	}

	.el-row .el-button--primary {
		background: rgba(0, 193, 200, 1);
		border: 1px solid rgba(0, 193, 200, 1);
	}

	.el-row .el-button--primary:first-child {
		margin-right: 15px;
	}

	#steps {
		margin: 50px auto !important;
	}

	.confirm-wrapper {
		margin: 0 110px 0 40px;
	}

	.confirm-wrapper table.border th,
	table.border td {
		border: 1px solid #7e7e7e;
	}

	.operation {
		font-size: 20px;
		margin-left: 8px;
		position: absolute;
		cursor: pointer;
	}

	.operation.el-icon-circle-plus-outline {
		right: -40px;
	}

	.operation.el-icon-remove-outline {
		right: -70px;
	}

	#message {
		margin-left: 5px;
		display: flex;
		justify-content: space-between;
	}

	#steps {
		width: 80%;
		margin: auto;
	}

	.wrapper {
		width: 80%;
		overflow-x: auto;
	}
</style>
